import SideMenu from '@/containers/side-menu/SideMenu.vue'
import GuardConfig from '@/pages/guard/guard-config/GuardConfig'

export default {
  path: '/guard-config',
  name: 'GuardConfig',
  components: {
    mainContent: GuardConfig,
    mainMenu: SideMenu
  },
  meta: {
    role: {
      sectorId: 'guard-notifications'
    },
    breadcrumb: {
      title: 'Configuração para Exportação',
      paths: [
        { title: 'Guarda Municipal' },
        { title: 'Configurações' },
      ]
    }
  }
}